import { useMediaQuery } from "react-responsive";

export const useScreenSize = () => {
  const isMobile = useMediaQuery({
    query: "(max-width: 767px)",
  });

  const isTablet = useMediaQuery({
    query: "(max-width: 1023px)",
  });

  return {
    isMobile,
    isTablet: isTablet && !isMobile,
    isDesktop: !isTablet && !isMobile,
  };
};
